import Layout from '@/pages/Layout.vue'

import Login from '@/pages/Login.vue'
import LoginSuccess from '@/pages/LoginSuccess.vue'
import LoginError from '@/pages/LoginError.vue'

import Route404 from '@/pages/404.vue'

const routes = [
	{
		path: '/login/:token',
		component: Login
	},
	{
		path: '/login_success',
		component: LoginSuccess
	},
	{
		path: '/login_error',
		component: LoginError
	},
	{
		path: '*',
		component: Route404
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js